export default {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hideDialog() {
            document.body.classList.remove("modal-open");
            this.$emit('update:show', false)
        }
    },
    mounted() {
    }
}
